import Constants from '@usas/ui-web/utils/Constants';
import { CommonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

export const INITIAL_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
  dataAsOptionsWithNames: [],
  message: ''
};

const getTouchpointSubjects = (state, setState) => {
  if (state.isLoading !== true && state.isLoaded !== true && !state.message) {
    const newState = {
      ...state,
      isLoading: true,
      isLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/TouchpointSubject`;
    CommonHttpHelper(url, 'GET')
      .then((data) => {
        if (!data) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          data.unshift({ touchpointSubjectId: Constants.DEFAULT_ID, subjectName: '--' });
          setState({
            ...newState,
            isLoading: false,
            isLoaded: true,
            data: data,
            dataAsOptionsWithNames: data.map((o) => { return { id: o.touchpointSubjectId, name: o.subjectName } }),
            message: '',
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isLoading: false,
          isLoaded: false,
          message: message
        });
      });
  }
};

const TouchpointSubjectData = { INITIAL_STATE, getTouchpointSubjects };

export default TouchpointSubjectData;